var _desc, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIllustration(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "121px",
    height: "94px",
    viewBox: "0 0 121 94",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Illustration") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Journey-8---Settings",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "3.8---cookies---confirmation-message",
    transform: "translate(-660.000000, -387.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Confirmation-message",
    transform: "translate(374.000000, 323.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Illustration",
    transform: "translate(287.000000, 64.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "stamp-document"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M115,55.2212389 C115,24.7239292 90.375125,0 60,0 C29.624875,0 5,24.7239292 5,55.2212389 C5,63.3470442 6.76275,71.0545487 9.9005,78 L110.0995,78 C113.23725,71.0545487 115,63.3470442 115,55.2212389",
    id: "Fill-1",
    fill: "#F4F6FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,78 L3,78",
    id: "Stroke-5",
    stroke: "#7450C8",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116,78 L119,78",
    id: "Stroke-7",
    stroke: "#7450C8",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6,78 L113,78",
    id: "Stroke-3",
    stroke: "#7450C8",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(23.000000, 23.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M66,68 C66,69.6571429 52.7914921,71 36.5,71 C20.2066349,71 7,69.6571429 7,68 C7,66.3428571 20.2066349,65 36.5,65 C52.7914921,65 66,66.3428571 66,68",
    id: "Fill-9",
    fill: "#DFE4EE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73,42 L72.9925241,4.66481481 C72.9925241,2.08888889 70.8843288,0 68.2827261,0 L4.70792903,0 C2.10819529,0 0,2.08888889 0,4.66481481 L0.00747586984,42 L73,42 Z",
    id: "Fill-11",
    fill: "#DFE4EE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.45488654,42 L52,0 L4.7255673,0 C2.11609365,0 0,2.08888889 0,4.66481481 L0.00750387821,42 L9.45488654,42 Z",
    id: "Fill-13",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73,42 L73,51.3333333 C73,53.9111111 70.8915888,56 68.2878505,56 L4.70841121,56 C2.10841121,56 0,53.9111111 0,51.3333333 L0,42 L73,42 Z",
    id: "Fill-15",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73,42 L73,51.3333333 C73,53.9111111 70.8915888,56 68.2878505,56 L4.70841121,56 C2.10841121,56 0,53.9111111 0,51.3333333 L0,42 L73,42 Z",
    id: "Stroke-17",
    stroke: "#7450C8",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39,49.5 C39,50.8809524 37.8829365,52 36.5,52 C35.1190476,52 34,50.8809524 34,49.5 C34,48.1210317 35.1190476,47 36.5,47 C37.8829365,47 39,48.1210317 39,49.5",
    id: "Fill-19",
    fill: "#F4F6FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39,49.5 C39,50.8809524 37.8829365,52 36.5,52 C35.1190476,52 34,50.8809524 34,49.5 C34,48.1210317 35.1190476,47 36.5,47 C37.8829365,47 39,48.1210317 39,49.5 Z",
    id: "Stroke-21",
    stroke: "#7450C8",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-23",
    fill: "#FFFFFF",
    points: "48 66 24 66 25.2 57 46.8 57"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Stroke-25",
    stroke: "#7450C8",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    points: "48 66 24 66 25.2 57 46.8 57"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17,66 L55,66",
    id: "Stroke-27",
    stroke: "#7450C8",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73,42 L72.9925241,4.66481481 C72.9925241,2.08888889 70.8843288,0 68.2827261,0 L4.70792903,0 C2.10819529,0 0,2.08888889 0,4.66481481 L0.00747586984,42 L73,42 Z",
    id: "Stroke-29",
    stroke: "#7450C8",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("g", {
    id: "check-circle",
    transform: "translate(25.000000, 10.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#7450C8",
    cx: 11,
    cy: 11,
    r: 11
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.20281695,12.2237634 L7.4109082,10.3719367 C7.14549949,10.0516535 6.72876829,9.91214277 6.33204993,10.010763 C5.93533157,10.1093832 5.62558246,10.4294897 5.53015321,10.8394736 C5.43472396,11.2494574 5.5697207,11.6801233 5.87964073,11.9544068 L8.43175318,14.6030801 C8.63670284,14.8131631 8.9141535,14.9302774 9.20281695,14.9285526 C9.48771945,14.9273129 9.76074062,14.810422 9.96302066,14.6030801 L15.3930472,8.99148407 C15.5986417,8.78075 15.7142857,8.49388986 15.7142857,8.19463743 C15.7142857,7.895385 15.5986417,7.60852486 15.3930472,7.3977908 C14.9694644,6.96264116 14.2853624,6.96264116 13.8617797,7.3977908 L9.20281695,12.2237634 Z",
    id: "Path",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIllustration);
export default __webpack_public_path__ + "static/media/Illustration.a4944e17cc4a883e967f72a9ccbc0d46.svg";
export { ForwardRef as ReactComponent };